export default "__VITE_PUBLIC_ASSET__92f6c4cf__"